const Button = ({
  label,
  iconURL,
  backgroundColor,
  textColor,
  borderColor,
  fullWidth,
  onClick,
}) => {
  return (
    <button
      onClick={onClick}
      type="button"
      className={`flex justify-center items-center gap-2 px-7 py-4 border font-raleway text-lg leading-none
    ${
      backgroundColor
        ? `${backgroundColor} ${textColor} ${borderColor}`
        : "bg-[#ceac46] text-white border-[#ceac46]"
    } rounded-md ${fullWidth && "w-full"}`}
    >
      {label}

      {iconURL && (
        <img
          className="ml-2 rounded-full w-5 h-5"
          src={iconURL}
          alt="arrow-right icon"
        />
      )}
    </button>
  );
};

export default Button;
